import { render, staticRenderFns } from "./TestOne.vue?vue&type=template&id=f3ea067a&scoped=true&"
import script from "./TestOne.vue?vue&type=script&lang=js&"
export * from "./TestOne.vue?vue&type=script&lang=js&"
import style0 from "./TestOne.vue?vue&type=style&index=0&id=f3ea067a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ea067a",
  null
  
)

export default component.exports